import React from 'react';
import styled from 'styled-components';

const IconWrapper = styled.div`
  display: inline-flex;
  color: #ff9800;
`;

const WarningIcon: React.FC = () => {
  return (
    <IconWrapper>
      <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
    </IconWrapper>
  );
};

export default WarningIcon;
